module.exports = __webpack_public_path__ + "c_static/img/微信收款.d0b27db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/微信收款.jpg
// module id = ymmA
// module chunks = 33